import { render, staticRenderFns } from "./FADActa.vue?vue&type=template&id=89b5bbd2"
import script from "./FADActa.vue?vue&type=script&lang=js"
export * from "./FADActa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89b5bbd2')) {
      api.createRecord('89b5bbd2', component.options)
    } else {
      api.reload('89b5bbd2', component.options)
    }
    module.hot.accept("./FADActa.vue?vue&type=template&id=89b5bbd2", function () {
      api.rerender('89b5bbd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/FADActa.vue"
export default component.exports